import {useWholesaler} from 'context/wholesaler';
import {Form, Formik} from 'formik';
import Header from 'modules/header/wholesaler/main';
import {initialValues} from './utilities/initialValues';
import QualityFormComponent from 'components/forms/quality';
import {useState} from 'react';
import {QualifyFormSchema} from 'pages/farm/createAd/form/quality/utilities/validationSchema';
import {useNavigate} from 'react-router-dom';
import {existingUnits} from 'utilities/helper/existingUnitsOption';

const QualityForm = () => {
  const {wholesaler, uploadQualifyForm} = useWholesaler();
  const [images, setImages] = useState<IUploadImage[]>(
    wholesaler?.images ? wholesaler.images : [],
  );
  const navigate = useNavigate();
  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      <Formik
        initialValues={initialValues(wholesaler)}
        validationSchema={QualifyFormSchema}
        onSubmit={values => {
          const qualifyData = {
            images,
            existing_unit: values.existing_unit,
            existing: values.existing,
          };
          uploadQualifyForm(qualifyData);
          navigate('/wholesaler/add-ad/owner');
        }}
      >
        <Form className="pb-[7vh]">
          <QualityFormComponent
            images={images}
            setImages={setImages}
            existingUnits={existingUnits}
          />
        </Form>
      </Formik>
    </>
  );
};

export default QualityForm;
